.successScreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fffbf1;
  display: flex;
  justify-content: center;
  z-index: 110;
}

.container {
  width: 100%;
  max-width: 450px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--ed-border, #ece5d8);
}

.logo {
  width: 132px;
  height: 32px;
  min-width: 132px;
  min-height: 32px;
  background-image: url(./img/logo.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 20px 120px 20px;
}

.check {
  margin-top: 20px;
  width: 90px;
  height: 80px;
  min-width: 90px;
  min-height: 80px;
  background-image: url(./img/icon.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.title {
  margin-top: 16px;
  color: #231e19;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 28px;
  font-style: normal;
  font-weight: 900;
  line-height: 34px;
  letter-spacing: -0.4px;
  padding: 0 20px;
}

.subtitle {
  margin-top: 8px;
  color: #231e19;
  text-align: center;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;
  padding: 0 20px;
}

.instruction {
  margin-top: 20px;
  width: 100%;
  border-radius: 32px;
  background: #f3eddf;
  padding: 24px 20px 20px 20px;
}

.item {
  margin-top: 16px;
  width: 100%;
  // height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;

  &:first-child {
    margin-top: 0;
  }
}

.itemIcon {
  margin-right: 8px;
  width: 40px;
  min-width: 40px;
  min-height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.items {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  &::before {
    content: '';
    width: 2px;
    height: 82%;
    min-width: 2px;
    position: absolute;
    left: 19px;
    top: 12px;
    background-image: url(./img/line.svg);
    background-size: 2px;
    background-position: center center;
    z-index: 1;
  }
}

.item {
  &:nth-child(1) {
    .itemIcon {
      background-image: url(./img/icon1.png);
    }
  }

  &:nth-child(2) {
    .itemIcon {
      background-image: url(./img/icon2.png);
    }
  }

  &:nth-child(3) {
    .itemIcon {
      background-image: url(./img/icon3.png);
    }
  }

  &:nth-child(4) {
    margin-top: 18px;
    .itemIcon {
      background-image: url(./img/icon4.png);
    }
  }
}

.itemText {
  padding: 9px 0;
  color: #231e19;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;

  b {
    font-weight: 700;
  }
}

.divider {
  width: 100%;
  height: 2px;
  background-color: #ece5d8;
  margin: 26px 0 24px 0;
}

.itemDot {
  position: relative;
  padding: 0 8px 0 20px;
  margin-top: 16px;

  &::before {
    content: '';
    width: 4px;
    height: 4px;
    min-width: 4px;
    min-height: 4px;
    border-radius: 4px;
    position: absolute;
    left: 6px;
    top: 5px;
    background-color: var(--ed-brand, #ae66f6);
  }

  &:first-child {
    margin-top: 0;
  }

  p {
    color: #7b766f;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.045px;

    b,
    span {
      font-weight: 700;
      word-break: break-all;
    }
  }
}

.policy {
  width: 100%;
  margin: 20px 0 0 0;

  img {
    max-width: 100%;
    display: block;
    width: calc(100% - 14px);
    margin-left: auto;
    margin-right: auto;
  }
}

.buttonWrapper {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
  min-height: 120px;
  padding: 40px 20px 20px 20px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: linear-gradient(0deg, #fffbf1 0%, #fffbf1 66%, rgba(255, 251, 241, 0) 100%);
  z-index: 3;
}

.button {
  width: 100%;
  max-width: 390px;
  height: 60px;
  min-height: 60px;
  border-radius: 48px;
  background-color: var(--ed-brand, #ba61fe);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;

  p {
    color: #fff;
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.088px;
  }

  &:active {
    opacity: 0.5;
  }
}

// Dark mode
:global body.dark {
  :local {
    .successScreen,
    .content {
      background-color: #181716;
    }

    .divider {
      background-color: #ece5d8;
    }

    .title,
    .subtitle,
    .itemText,
    .itemDot p {
      color: #fffbf2;
    }

    .instruction {
      background-color: #2a2928;
    }

    // .policy img {
    //   filter: invert(1) grayscale(100%);
    // }

    .buttonWrapper {
      background: linear-gradient(0deg, #181716 0%, #181716 66%, rgba(255, 251, 241, 0) 100%);
    }
  }
}
